/**
 * getNewPathname() is a function that returns the string of the new
 * pathname of a blog post. It is needed for miltilingual supports.
 * @param {array} slugs is the array of each slug of the blog posts
 * @param {string} pathname is the pathname value of the location object
 * @param {string} toLangKey is the destination lang that we want
 */
const getNewPathname = (slugs, pathname, toLangKey) => {
  //* le but est de transformer pathname avec le bon slug pour les blog post

  // console.log(slugs);
  // console.log('pathname: ' + pathname);
  // console.log('toLangKey: ' + toLangKey);

  //? 1) récupérer l'ancien slug (apres le 'blog/')
  //? 2) rechercher dans slugs l'id de ce slug
  //? 3) enlever ou ajouter '___en' en fonction de toLangKey
  //? 4) retrouver le nouveau slug
  //? 5) créer et retourner le newpathname

  //* 1) récupérer l'ancien slug
  const slugRegex = /blog\/([^&]+)/;
  const olgSlugArray = pathname.match(slugRegex);
  const oldSlug = olgSlugArray[1];

  // console.log(oldSlug)

  //* 2) rechercher dans slugs l'id de oldSlug
  const oldSlugId = slugs.filter(edge => edge.node.slug === oldSlug)[0].node.id;

  // console.log(oldSlugId);

  //* 3) enlever ou ajouter '___en' en fonction de toLangKey
  let newSlugId;
  if (toLangKey === 'en') {
    newSlugId = oldSlugId + '___en';
  } else {
    newSlugId = oldSlugId.replace('___en', '');
  }

  // console.log(newSlugId);

  //* 4) retrouver le newSlug
  const newSlug = slugs.filter(edge => edge.node.id === newSlugId)[0].node.slug;

  // console.log(newSlug);

  //* 5) créer le newPathname
  const newPathname = `/${toLangKey}/blog/${newSlug}`;

  // console.log(newPathname);

  return newPathname;
};

export default getNewPathname;



// WEBPACK FOOTER //
// ./src/utils/js/getNewPathname.js